import PropTypes from 'prop-types';
import { themeGet } from '@styled-system/theme-get';

// Components
import Link from '../../../Core/Link';
import RichText, { fragment, all } from '../../../Core/RichText';

import {
  StyledContainer,
  Block,
  Img,
  Body,
  CopyWrapper,
  Features,
  Footer,
  BodyWrapper,
  Disclaimer,
} from './styles';

// color map for container background
const color = {
  default: 'transparent',
  grey: themeGet('colors.stone'),
  white: themeGet('colors.white'),
};

const PCCardSpecList = ({ data, className = '', bladeType = null }) => {
  if (!data) return null;
  const {
    backgroundColor,
    imageDam,
    header,
    bodyCopy,
    listOfFeatures,
    ctas,
    component,
    disclaimer,
  } = data;

  return (
    <StyledContainer
      as="section"
      backgroundColor={color[backgroundColor]}
      className={
        bladeType
          ? `${className} ${component} ${bladeType}`
          : `${className} ${component}`
      }
    >
      <Block className={bodyCopy ? 'center' : ''}>
        <BodyWrapper>
          {imageDam && <Img src={imageDam} alt={imageDam.altText || ''} />}
          <Body className={component}>
            <RichText document={header} options={all} />
            {bodyCopy ? (
              <>
                <CopyWrapper>
                  <RichText document={bodyCopy} />
                </CopyWrapper>
                {listOfFeatures && <Features data={listOfFeatures} />}
              </>
            ) : (
              <Features data={listOfFeatures} />
            )}
            {ctas ? (
              <Footer>
                {ctas &&
                  ctas.map(cta => {
                    if (cta.hideFrench === true) return null;
                    return (
                      <Link key={cta.id} data={cta}>
                        <RichText document={cta.label} options={fragment} />
                      </Link>
                    );
                  })}
              </Footer>
            ) : null}
          </Body>
        </BodyWrapper>
        {disclaimer && (
          <Disclaimer>
            <RichText document={disclaimer} />
          </Disclaimer>
        )}
      </Block>
    </StyledContainer>
  );
};

PCCardSpecList.propTypes = {
  data: PropTypes.shape().isRequired,
  className: PropTypes.string,
  bladeType: PropTypes.string,
};

export default PCCardSpecList;
